import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { LinkText } from '@styled';
import colors from '@general/colors';
import { mediaQueries } from '@general/breakpoints';

// show mobile view for phones & tablets
const breakpoint = mediaQueries.lg;

const Item = styled.li`
    margin: 10px 0 18px 0;
    position: relative;
    font-weight: normal;

    @media ${breakpoint} {
        margin: 10px 18px 18px 0;

        span {
            font-weight: ${props => (props.active ? 'bold' : 'normal')} !important;
        }
    }

    &:before {
        @media ${breakpoint} {
            display: ${props => (props.active ? 'block' : 'none')};
            content: ' ';
            position: absolute;
            left: -20px;
            top: 8px;
            height: 10px;
            width: 10px;
            background-color: ${colors.primary};
            border-radius: 100%;
        }
    }

    a {
        color: ${props => (props.active ? `${colors.black}` : '#7f7f7f')};
        border-bottom: ${props => (props.active ? `3px solid ${colors.primary}` : 'none')};
        @media ${breakpoint} {
            color: ${colors.black};
            border-bottom: none;
        }
    }
`;

const SubList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;

    li::marker {
        display: none; /* Hides the default marker for list items */
    }
`;

const SubnavItem = ({ label, to, children }) => {
    const location = useLocation();
    const history = useHistory();
    const [isExpanded, setIsExpanded] = useState(false);
    const match = location.pathname.includes(to);

    useEffect(() => {
        if (match && children) {
            setIsExpanded(true); // Expand the subnav if on the correct route
            const firstChild = React.Children.toArray(children)[0];
            if (firstChild?.props?.to && location.pathname === to) {
                history.push(firstChild.props.to); // Redirect to the first child
            }
        }
    }, [match, children, to, history, location.pathname]);

    const toggleExpand = () => {
        setIsExpanded(prev => !prev);
    };

    return (
        <Item active={match}>
            <Link to={to} onClick={toggleExpand}>
                <LinkText>{label}</LinkText>
            </Link>
            {match && children && (
                <SubList>
                    {children}
                </SubList>
            )}
        </Item>
    );
};

SubnavItem.propTypes = {
    label: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    children: PropTypes.node,
};

export default SubnavItem;
